import {
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  IconSizeEnum,
  TIcon,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';

type ItemListProps = {
  title: string;
  titleIcon?: TIcon;
  children?: React.ReactNode;
  contentIcon?: TIcon | null;
  classNamesChildren?: string;
  isSubItem?: boolean;
  classname?: string;
  onClick?: () => void;

  /**
   * Text below the title that uses the full width of the container ideal for
   * description fields.
   */
  description?: string;
};

export function ItemList({
  title,
  titleIcon: TitleIcon,
  children,
  contentIcon: ContentIcon,
  isSubItem,
  classNamesChildren = '',
  description,
  classname,
  onClick,
}: ItemListProps) {
  const initialPadding = isSubItem ? 'pl-size-32' : 'pl-size-16';

  return (
    <div
      className={clsx('min-h-[40px] w-full px-size-4 py-2', onClick && 'cursor-pointer', classname)}
      onClick={onClick}
    >
      <div className="item-list relative flex gap-size-8 self-stretch">
        <div
          className={clsx('frame flex w-[45%] flex-wrap items-center pr-size-16', initialPadding)}
        >
          {TitleIcon && <TitleIcon className="mr-2" size={IconSizeEnum.MD} />}

          <Typography
            color={FontColorEnum.Dark10}
            weight={FontWeightEnum.Regular}
            fontSize={FontSizeEnum.Body3}
            className="line-clamp-1 break-all"
          >
            {title}
          </Typography>
        </div>

        <div
          className={`action flex w-[55%] flex-wrap items-center gap-size-12 overflow-hidden break-all ${classNamesChildren}`}
        >
          <div className="flex w-full gap-2 text-text-dark-10">
            {ContentIcon && <ContentIcon />}

            {children}
          </div>
        </div>
      </div>

      {description && (
        <div className={initialPadding}>
          <div className="px-[12px] py-[5px]">
            <Typography className="whitespace-break-spaces text-text-medium-10">
              {description}
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
}
